import { render } from "./TandCCreate.vue?vue&type=template&id=32c57384&scoped=true"
import script from "./TandCCreate.vue?vue&type=script&lang=js"
export * from "./TandCCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c57384"]])

export default __exports__